function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
/* eslint-disable */ // ReSharper disable InconsistentNaming
export class CollectionClient {
    getBranches() {
        let url_ = this.baseUrl + "/api/v1/collection/branches";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response)=>{
            return this.processGetBranches(_response);
        });
    }
    processGetBranches(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k)=>_headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then((blob)=>{
                return {
                    fileName: fileName,
                    data: blob,
                    status: status,
                    headers: _headers
                };
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText)=>{
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getTitleByISBN(isbn) {
        let url_ = this.baseUrl + "/api/v1/collection/isbn/{isbn}";
        if (isbn === undefined || isbn === null) throw new globalThis.Error("The parameter 'isbn' must be defined.");
        url_ = url_.replace("{isbn}", encodeURIComponent("" + isbn));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response)=>{
            return this.processGetTitleByISBN(_response);
        });
    }
    processGetTitleByISBN(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k)=>_headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText)=>{
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText)=>{
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getItemById(id) {
        let url_ = this.baseUrl + "/api/v1/collection/details/{id}";
        if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response)=>{
            return this.processGetItemById(_response);
        });
    }
    processGetItemById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k)=>_headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText)=>{
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText)=>{
                let result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText)=>{
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    search(query, medium, genre, location, status, ageFrom, ageTo, limit, offset) {
        let url_ = this.baseUrl + "/api/v1/collection/search?";
        if (query !== undefined && query !== null) url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (medium !== undefined && medium !== null) medium && medium.forEach((item)=>{
            url_ += "medium=" + encodeURIComponent("" + item) + "&";
        });
        if (genre !== undefined && genre !== null) genre && genre.forEach((item)=>{
            url_ += "genre=" + encodeURIComponent("" + item) + "&";
        });
        if (location !== undefined && location !== null) url_ += "location=" + encodeURIComponent("" + location) + "&";
        if (status !== undefined && status !== null) status && status.forEach((item)=>{
            url_ += "status=" + encodeURIComponent("" + item) + "&";
        });
        if (ageFrom !== undefined && ageFrom !== null) url_ += "ageFrom=" + encodeURIComponent("" + ageFrom) + "&";
        if (ageTo !== undefined && ageTo !== null) url_ += "ageTo=" + encodeURIComponent("" + ageTo) + "&";
        if (limit === null) throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined) url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null) throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined) url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response)=>{
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k)=>_headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText)=>{
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText)=>{
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText)=>{
                let result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText)=>{
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getDefaultFacets() {
        let url_ = this.baseUrl + "/api/v1/collection/facets";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response)=>{
            return this.processGetDefaultFacets(_response);
        });
    }
    processGetDefaultFacets(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k)=>_headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText)=>{
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText)=>{
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    recommendById(id) {
        let url_ = this.baseUrl + "/api/v1/collection/recommend/{id}";
        if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response)=>{
            return this.processRecommendById(_response);
        });
    }
    processRecommendById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k)=>_headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText)=>{
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText)=>{
                let result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText)=>{
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    constructor(baseUrl, http){
        _define_property(this, "http", void 0);
        _define_property(this, "baseUrl", void 0);
        _define_property(this, "jsonParseReviver", undefined);
        this.http = http ? http : window;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }
}
export class ApiException extends Error {
    static isApiException(obj) {
        return obj.isApiException === true;
    }
    constructor(message, status, response, headers, result){
        super(), _define_property(this, "message", void 0), _define_property(this, "status", void 0), _define_property(this, "response", void 0), _define_property(this, "headers", void 0), _define_property(this, "result", void 0), _define_property(this, "isApiException", true);
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
}
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined) throw result;
    else throw new ApiException(message, status, response, headers, null);
}
